import { z } from "zod";

const IMSI_LENGTH = 15;

export const selectNumberSchema = z
  .object({
    isAuthenticated: z.boolean(),
    msisdnId: z.string().min(1),
    msisdnNumber: z.string().min(1, { message: "Mobile Number is required" }),
    imsiNumber: z.string().optional(),
  })
  .superRefine((data, context) => {
    if (data.isAuthenticated) {
      if (data.imsiNumber) {
        if (data.imsiNumber.length !== IMSI_LENGTH) {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            message: `IMSI Number must be ${IMSI_LENGTH} digits`,
            path: ["imsiNumber"],
          });
        }
      } else {
        context.addIssue({
          code: z.ZodIssueCode.custom,
          message: "IMSI Number is required",
          path: ["imsiNumber"],
        });
      }
    }
  });
